import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["link"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { parseUrl, isTrustedUrl } from '../../helpers/url';
import PotentialLink from '../potential-link';
import { useGetHrefContext } from '../../context';
import { jsx as _jsx } from "react/jsx-runtime";
export function processLink(link, currentHref) {
  const {
    origin
  } = parseUrl(link) || {
    origin: undefined
  };
  const looksExternal = Boolean(origin);
  const parsedCurrentHref = parseUrl(currentHref);
  const reallyInternal = (parsedCurrentHref && parsedCurrentHref.origin) === origin;
  const isExternal = looksExternal && !reallyInternal;
  let processedLink = link;
  if (reallyInternal) {
    processedLink = (link || '').slice((origin || '').length);
  } else if (isExternal) {
    processedLink = isTrustedUrl(link);
  }
  return {
    isExternal,
    processedLink
  };
}
const AutoPotentialLink = _ref => {
  let {
      link
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const currentHref = useGetHrefContext()();
  const {
    processedLink,
    isExternal
  } = processLink(link, currentHref);
  return /*#__PURE__*/_jsx("div", {
    "data-id": "auto-potential-link_index_AutoPotentialLink_div",
    children: /*#__PURE__*/_jsx(PotentialLink, _objectSpread(_objectSpread({}, props), {}, {
      external: isExternal,
      link: processedLink,
      "data-id": "auto-potential-link_index_AutoPotentialLink_div_PotentialLink"
    }))
  });
};
export default AutoPotentialLink;